import { z } from "zod";

export const getFromIdPayloadSchema = z.object({
  id: z.string().uuid()
}).strip();
export const getFromIdsPayloadSchema = z.object({
  ids: z.string().uuid().array()
});
export type getFromIdPayload = z.infer<typeof getFromIdPayloadSchema>;
export type getFromIdsPayload = z.infer<typeof getFromIdsPayloadSchema>;

export const getFromMaterialIdPayloadSchema = z.object({
  id: z.number(),
}).strip();
export type getFromMaterialIDPayload = z.infer<typeof getFromMaterialIdPayloadSchema>;

// 整数 PK(工事 Work 等)を id で受けるペイロード。搬入/施工計画の「工事から取得」で使う。
export const getFromIntIdPayloadSchema = z.object({
  id: z.number(),
}).strip();
export type getFromIntIdPayload = z.infer<typeof getFromIntIdPayloadSchema>;

export const getFromNamePayloadSchema = z.object({
  name: z.string(),
}).strip();
export type getFromNamePayload = z.infer<typeof getFromNamePayloadSchema>;

export const setDeletePayloadSchema = z.object({
  id: z.string().uuid(),
  deleted: z.boolean(),
}).strip();
export type setDeletePayload = z.infer<typeof setDeletePayloadSchema>;